module.exports = __webpack_public_path__ + "img/yishu.e117994a.png";